module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/038-98657cf920b05b75eb948d44f61b26be.jpg";